<template>
  <div class=" p-10">
    <div v-if="template.id_copy_template !== null">
      <form id="copyForm" class="row">
      <!-- Primary Language -->
        <div class="col-sm-7 pt-3">

          <div class="support-tickets-header">
              <div class="tickets-filter">
                  <div class="form-group row mr-3">
                      <label class="col-form-label col-sm-4">Locale</label>
                      <div class="col-sm-8">
                        <input disabled class="form-control d-md-inline-block locale col-sm-3"  v-model="primaryLanguage" />
                      </div>
                  </div>
              </div>
          </div>

          <div v-for="(language, currentLanguage) in currentHeaders" v-if="currentLanguage == primaryLanguage">
            <div class="form-group row" v-for="(header, index) in language" v-bind:key="header.header_name" :class="{'rtl': header.is_rtl == 1}" v-if="header.is_visible == 1">
              <label class="col-form-label col-sm-4 bold" for="">
                {{formatHeaderName(header.header_name)}}
                <span class="required-field" v-if="header.is_required == 1">*</span>
              </label>

              <div class="col-sm-8">
                <EditorTwo
                  v-if="header.header_type == 'textarea'"
                  :placeholder="'Enter '+formatHeaderName(header.header_name)"
                  :initialContent="header"
                  :disabled='false'
                  :language=currentLanguage
                  @contentInterface="updateCopyValue($event, header)"
                />
                <input v-if="header.header_type == 'text'" class="form-control" :name="header.header_name" :placeholder="'Enter '+formatHeaderName(header.header_name)" @change="updateCopy(header)" v-model="header.value" />

                <select v-if="header.header_type == 'dropdown'" :name="header.header_name" class="form-control" @change="updateCopy(header)" v-model="header.value">
                  <option value="">Select an option</option>
                  <option v-for="(filter) in stringToArray(header.default_value)" :value="filter">{{filter}}</option>
                </select>

                <treeselect v-if="header.header_type == 'dropdown_multiple'" v-model="header.value" :multiple="true" :options="header.options" :value-consists-of="valueConsistsOf" :normalizer="normalizer"/>

                <div v-if="header.header_type == 'metric'" class="row">
                  <div class="col-sm-8">
                    <input class="form-control" :name="header.header_name" :placeholder="'Enter '+formatHeaderName(header.header_name)" v-model="header.value" />
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control" v-model="header.value_dropdown">
                      <option value="">Select an option</option>
                      <option v-for="(filter) in stringToArray(header.default_value)" :value="filter">{{filter}}</option>
                    </select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5 pt-3">
          <div class="support-tickets-header">
            <div class="tickets-filter">
                <div class="form-group row mr-3">
                    <label class="col-form-label col-sm-4">Locale</label>
                    <div class="col-sm-8">
                    <select class="form-control-sm" v-model="secondaryLanguage">
                        <option v-for="(language, index) in languages" @change="updateSecondary(language)" :value="language">{{language}}</option>
                    </select>
                    </div>
                </div>

            </div>
          </div>

          <div v-for="(language, currentLanguage) in currentHeaders" v-if="currentLanguage == secondaryLanguage">
            <div class="form-group row" v-for="(header, index) in language" v-bind:key="header.header_name" :class="{'rtl': header.is_rtl == 1}" v-if="header.is_visible == 1" >
              <!-- <label class="col-form-label col-sm-4 bold" for="">
                {{formatHeaderName(header.header_name)}}
                <span class="required-field" v-if="header.is_required == 1">*</span>
              </label> -->
              <div class="col-sm-12">
                <EditorTwo
                  v-if="header.header_type == 'textarea'"
                  :placeholder="'Enter '+formatHeaderName(header.header_name)"
                  :initialContent="header"
                  :disabled='true'
                  :language=currentLanguage
                  @contentInterface="updateCopyValue($event, header)"
                />
                <input disabled v-if="header.header_type == 'text'" class="form-control" :name="header.header_name" :placeholder="'Enter '+formatHeaderName(header.header_name)" @change="updateCopy(header)" v-model="header.value" />
                <select disabled v-if="header.header_type == 'dropdown'" :name="header.header_name" class="form-control" @change="updateCopy(header)" v-model="header.value">
                  <option value="">Select an option</option>
                  <option v-for="(filter) in stringToArray(header.default_value)" :value="filter">{{filter}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12" v-else>
      <EmptyState>
        <div slot="empty_state_text">
          No template found for this product
        </div>
      </EmptyState>
    </div>
  </div>
</template>

<script>
import EmptyState from '@/components/common/EmptyState'
import Editor from '@/components/common/Editor/Editor'
import EditorTwo from '@/components/common/Editor/Editor2'
import Treeselect from '@riophae/vue-treeselect'
import CommonFunctions from '@/mixins/common-functions.js'
import { debounce } from 'underscore'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  mixins: [CommonFunctions],
  props: ['product', 'headers', 'template', 'primaryLanguage'],
  components: { Editor, EmptyState, EditorTwo, Treeselect },
  data: function () {
    return {
      valueConsistsOf: 'ALL_WITH_INDETERMINATE',
      updateCopyInterval: '',
      languages: [],
      secondaryLanguage: 'ar',
      currentHeaders: {},
      newHeaders: {},
      memorySearch: {
        top: 0,
        isVisible: false,
        isTyping: false,
        searchFor: '',
        value: null
        // define options
      },
      normalizer (node) {
        return {
          id: node.value_code,
          label: node.value_en,
          children: node.children
        }
      },

      value: null,
      options: [ {
        id: 'keya',
        label: 'a',
        children: [ {
          id: 'aa',
          label: 'aa',
          children: [
            {
              id: 'aaa',
              label: 'aaa'
            }
          ]
        }, {
          id: 'ab',
          label: 'ab'
        } ]
      }, {
        id: 'b',
        label: 'b'
      }, {
        id: 'c',
        label: 'c'
      } ]
    }
  },
  mounted: function () {
    this.mapHeaders()
    this.updateCopyInterval = setInterval(this.updateCopy, 1000)
  },
  beforeDestroy: function () {
    clearInterval(this.updateCopyInterval)
  },
  methods: {
    updateCopy: function (header) {
      var self = this
      self.$emit('copyInterface', this.currentHeaders)
    },
    formatHeaderName: function (name) {
      return name
        .toLowerCase()
        .split('_')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join('_')
        .replace(/_/g, ' ')
    },
    getNestedChildren (arr, parent) {
      var out = []
      for (var i in arr) {
        if (arr[i].value_parent == parent) {
          var children = this.getNestedChildren(arr, arr[i].value_code)

          if (children.length) {
            arr[i].children = children
          }
          out.push(arr[i])
        }
      }
      return out
    },
    mapHeaders: function (headers) {
      var self = this

      const languageHeaders = {}
      const languages = [...new Set(self.headers.map(x => x.code))]
      self.languages = languages

      languages.map(function (language) {
        languageHeaders[language] = self.headers.map((val, i, headers) => {
          if (val.code != language) { return }

          var value = val.value
          var options = val.options
          if (val.header_type == 'dropdown_multiple' && val.value) {
            value = val.value.split(',')
          }
          if (val.header_type == 'dropdown_multiple' && val.value == '') {
            value = null
          }
          if (val.header_type == 'dropdown_multiple' && val.options) {
            options = self.getNestedChildren(val.options, 'ecommerce_uae')
          }
          return {
            id_copy_template_header: val.id_copy_template_header,
            language_code: val.code,
            id_copy_header: val.id_copy_header,
            header_name: val.header_name,
            header_type: val.header_type,
            default_value: val.default_value,
            is_visible: val.is_visible,
            is_required: val.is_required,
            is_rtl: val.is_rtl,
            value: value,
            value_dropdown: val.value_dropdown,
            new_value: '',
            options: options,
            children: options
          }
        }).filter((x) => {
          return x !== undefined
        })
      })

      self.currentHeaders = languageHeaders
    },
    updatePrimary (language) {
      this.primaryLanguage = language
      if (this.primaryLanguage == this.secondaryLanguage) {
        this.secondaryLanguage = ''
      }
    },
    updateSecondary (language) {
      this.secondaryLanguage = language
    },
    updateCopyValue (data, header) {
      header.value = data.value
    }
  },
  watch: {
    headers () {
      this.mapHeaders()
    }
  }
}
</script>

<style>
.rtl{
  direction: rtl;
}
.p-10 {
  padding: 10px !important;
}
.select2 {
  margin-bottom: 10px;
}
.pull-right {
  float: right;
}
.required-field{
  font-size: 12px;
  color: red;
}
.locale {
  display: inline-block;;
}
b, strong {
    font-weight: 700;
}
</style>
